import React, { useCallback } from 'react';
import UrlMultiInput from '../shared/UrlMultiInput';

const Step1_UrlInput = ({ urls, setUrls, onNext, loading, error }) => {
  const validUrlsCount = urls.length;

  const removeUrlAtIndex = useCallback((indexToRemove) => {
    setUrls(prev => prev.filter((_, index) => index !== indexToRemove));
  }, [setUrls]);

  const clearAll = useCallback(() => {
    setUrls([]);
  }, [setUrls]);

  const formatDisplayUrl = useCallback((url) => {
    return url.replace(/^https?:\/\//i, '').replace(/\/$/, '');
  }, []);

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Step 1: Add Doctor Page URLs</h2>
        <p className="text-gray-600">Enter the URLs of doctor pages you want to scrape</p>
      </div>

      {/* URL Input Section */}
      <div className="bg-gray-50 p-6 rounded-lg">
        <div className="mb-4">
          <UrlMultiInput
            urls={urls}
            setUrls={setUrls}
            rows={4}
            placeholder="example1.com, example2.com (press Enter after each URL)"
            label="Paste or type doctor page URLs:"
            description="Hint: example1.com, example2.com (press Enter after each URL)."
          />
        </div>

        {validUrlsCount > 0 && (
          <div className="space-y-2">
            <div className="flex items-center justify-between text-sm text-gray-600">
              <span>{validUrlsCount} URL{validUrlsCount !== 1 ? 's' : ''} ready to process</span>
              <button
                type="button"
                onClick={clearAll}
                className="text-xs text-red-600 hover:text-red-700 font-medium"
              >
                Clear all
              </button>
            </div>
            <div className="flex flex-wrap gap-2">
              {urls.map((url, index) => (
                <span
                  key={`${url}-${index}`}
                  className="inline-flex items-center px-3 py-1 text-sm bg-white border border-gray-300 rounded-full shadow-sm"
                >
                  <span className="max-w-xs truncate mr-2">{formatDisplayUrl(url)}</span>
                  <button
                    type="button"
                    onClick={() => removeUrlAtIndex(index)}
                    className="text-gray-500 hover:text-red-600"
                    aria-label={`Remove ${url}`}
                  >
                    ×
                  </button>
                </span>
              ))}
            </div>
          </div>
        )}

      </div>

      {/* Error Display */}
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <div className="text-red-800">{error}</div>
        </div>
      )}

      {/* Next Button */}
      <div className="flex justify-end">
        <button
          onClick={onNext}
          disabled={validUrlsCount === 0 || loading}
          className="px-8 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
        >
          {loading ? 'Loading...' : 'Next Step →'}
        </button>
      </div>
    </div>
  );
};

export default Step1_UrlInput;

